'use client';

import { createContext, PropsWithChildren, useContext, useRef } from 'react';
import { useStore } from 'zustand';
import { AccountDataState, AccountDataStore, createAccountDataStore } from '../stores/account-data-store';

type BillingProfileStoreApi = ReturnType<typeof createAccountDataStore>;

const BillingProfileStoreContext = createContext<BillingProfileStoreApi | undefined>(undefined);

type BillingProfileStoreProviderProps = PropsWithChildren<AccountDataState>;

export const AccountDataStoreProvider = ({ children, ...props }: BillingProfileStoreProviderProps) => {
	const storeRef = useRef<BillingProfileStoreApi | null>(null);
	if (!storeRef.current) {
		storeRef.current = createAccountDataStore(props);
	}

	return <BillingProfileStoreContext.Provider value={storeRef.current}>{children}</BillingProfileStoreContext.Provider>;
};

export const useAccountDataStore = <T,>(selector: (store: AccountDataStore) => T): T => {
	const context = useContext(BillingProfileStoreContext);

	if (!context) {
		throw new Error('useAccountDataStore must be used within a AccountDataStoreProvider');
	}

	return useStore(context, selector);
};
